
export default {
  props: {
    type: {
      default: "",
      type: String
    },
    itemProp: {
      default: () => {},
      type: Object
    },
    parentItemProp: {
      default: () => {},
      type: Object
    },
    classProp: {
      default: "dots-horizontal",
      type: String
    }
  }
};
